import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Configuration } from "../../../app.constants";
import { BehaviorSubject, Observable } from "rxjs";
import { LanguageCode } from "../../../member-portal/shared/enum";
import { LanguageMenuItem } from "../../../member-portal/shared/languageMenuItem";
import { publishReplay, refCount, catchError } from "rxjs/operators";
import { HttpResponseHelper } from "../helpers/http-response-helper";

export interface INotifyChange {
  propName: string;
  value: any;
}

@Injectable()
export class LanguageService {
  private _languageChangeSubject = new BehaviorSubject<INotifyChange>({
    propName: "languageCode",
    value: '', //LanguageCode.en,
  });
  public notifyObservable$ = this._languageChangeSubject.asObservable();
  private _languageCode: string; // = LanguageCode.en;

  constructor(private http: HttpClient, private configuration: Configuration) {
    // Load default language from localStorage or fall back to 'en'
    this._languageCode = localStorage.getItem('selectedLanguageCode') || LanguageCode.en;
  }

  public get languageDir(): string {
    return this._languageCode === LanguageCode.arEG ? 'rtl' : 'ltr';
  }

  public get languageCode(): string {
    return this._languageCode;
  }

  public set languageCode(value: string) {
    if (this._languageCode !== value) {
      this._languageCode = value;
      localStorage.setItem('selectedLanguageCode', value); // Save globally
      this._languageChangeSubject.next({ propName: 'languageCode', value });
      // document.dir = value === 'ar-EG' ? 'rtl' : 'ltr';
      // document.body.setAttribute('dir', value === 'ar-EG' ? 'rtl' : 'ltr');
      // const data: INotifyChange = { propName: "languageCode", value: value };
      // this.notifyChange(data);
    }
  }

  public notifyChange(data: any) {
    this._languageChangeSubject.next(data);
  }

  public getLanguageMenuItems(): Observable<Array<LanguageMenuItem>> {
    return this.http
      .get<Array<LanguageMenuItem>>(this.configuration.GetLanguageMenuUrl)
      .pipe(
        publishReplay(1),
        refCount(),
        catchError((error) =>
          HttpResponseHelper.handleError(this.configuration, error)
        )
      );
  }

  public getContentServiceUrlWithParameter(parameter: string) {
    let siteCoreContentServiceUrl =
      this.configuration.SitecoreContentServiceUrl.replace(/\/$/, "");
    let param = parameter.replace(/\/$/, "");
    return siteCoreContentServiceUrl + "/" + param + "/" + this.languageCode;
  }
}
